module.exports = [
  {
    value: 'Epidural',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.EPIDURAL',
    active: true,
  },
  {
    value: 'Inhalation',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.INHALATION',
    active: true,
  },
  {
    value: 'Intramuscular',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.INTRAMUSCULAR',
    active: true,
  },
  {
    value: 'Intrathecal',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.INTRATHECAL',
    active: true,
  },
  {
    value: 'Intravenous',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.INTRAVENOUS',
    active: false,
  },
  {
    value: 'Central Intravenous',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.CENTRALINTRAVENOUS',
    active: true,
  },
  {
    value: 'Peripheral Intravenous',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.PERIPHERALINTRAVENOUS',
    active: true,
  },
  {
    value: 'Intravesicular',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.INTRAVESICULAR',
    active: true,
  },
  {
    value: 'Nasal',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.NASAL',
    active: false,
  },
  {
    value: 'Naso-gastric',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.NASOGASTRIC',
    active: true,
  },
  {
    value: 'Optical',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.OPTICAL',
    active: true,
  },
  {
    value: 'Oral',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.ORAL',
    active: true,
  },
  {
    value: 'Per ear',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.PER_EAR',
    active: true,
  },
  {
    value: 'Per vagina',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.PER_VAGINA',
    active: true,
  },
  {
    value: 'Rectal',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.RECTAL',
    active: true,
  },
  {
    value: 'Subcutaneous',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.SUBCUTANEOUS',
    active: true,
  },
  {
    value: 'Sublingual',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.SUBLINGUAL',
    active: true,
  },
  {
    value: 'Topical',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.TOPICAL',
    active: true,
  },
  {
    value: 'Other',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.OTHER',
    active: true,
  },
  {
    value: 'Unknown',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.UNKNOWN',
    active: true,
  },
  {
    value: 'Not applicable',
    label: 'MEDICATIONS.V2.FORM.OPTION.ROUTE.NOT_APPLICABLE',
    active: true,
  },
];
